import { render, staticRenderFns } from "./UserIdentityCard.vue?vue&type=template&id=ed25b260&"
import script from "./UserIdentityCard.vue?vue&type=script&lang=js&"
export * from "./UserIdentityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports